export const sendMail = async (formData) => {
  try {

    const response = await fetch(
      "https://indiaembroideryco.com/server/send-mail.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      }
    );

    const data = await response.json();

    return data;

  } catch (error) {
    console.error("Mail API Error:", error);

    return {
      status: "error",
      message: "Server error"
    };
  }
};